import './LocaleSwitcher.less';
import React from 'react';
import config from "../../../../../config.json";
import __, {getLocale} from "../../i18n";
import LabelMap from "../../../bootstrap/types/label-map/LabelMap";
import SingleSelect from "../../../bootstrap/components/single-select/SingleSelect";


export default function LocaleSwitcher() {
    const switchLocale = (locale) => {
        var url = new URL(location.href);
        url.searchParams.set('locale', locale);
        location.href = url.href;
    };

    return <div className="locale-switcher">
        <SingleSelect
            defaultValue={getLocale()}
            onChange={locale => switchLocale(locale)}
            appearance="default-borderless"
            options={new LabelMap([
                [
                    'vi',
                    <div className="locale-switcher-option-label">
                        <img src={config.img_locale_vn} width={23}/>
                        <span>{__('Tiếng Việt')}</span>
                    </div>
                ],
                [
                    'en',
                    <div className="locale-switcher-option-label">
                        <img src={config.img_locale_us} width={23}/>
                        <span>{__('English (US)')}</span>
                    </div>
                ],
            ])}
        />
    </div>;
}
